import { render, staticRenderFns } from "./ValueTreeFieldType5.vue?vue&type=template&id=4ab79d0d&scoped=true"
import script from "./ValueTreeFieldType5.vue?vue&type=script&lang=js"
export * from "./ValueTreeFieldType5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab79d0d",
  null
  
)

export default component.exports